import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import { Link } from 'react-router';
import { Button, Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemNhomDoiTuongThanhTra} from './datatable/list';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import {TextArea, Input} from 'components/tt-forms/common';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import {isEmpty} from 'lodash';
import classnames from 'classnames';

class NhomDoiTuongThanhTra extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      doiTuongTT: '',
      moTa: '',
      tableLoading:false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      timKiemNangCao: false
    };
  }

  componentDidMount() {
    this.getListData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.state.search = true;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    };
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getNhomDoiTuongThanhTra.request(null, params).then(res => {
     if (!isEmpty(res.data._embedded)) {
        this.setState({
          data: res.data._embedded.nhomDoiTuongThanhTras,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size,
        number: 0
      }
    }, () => {
      this.getListData();
    })
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  createCategory() {
    const editNum = 2;
    if(this.checkValidate()){
      let params = {
        ten: this.state.ten.trim(),
      };
      if (this.state.moTa) {
        params.moTa = this.state.moTa;
      }
      this.setState({buttonLoading: true});
      if (this.state.addType === editNum) {
        Danhmuc.actions.updateNhomDoiTuongThanhTra.request({id: this.state.doiTuongTT}, params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (!isEmpty(error.response)) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postNhomDoiTuongThanhTra.request('',params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (!isEmpty(error.response)) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getListData();
    })
  }

  handleDelete(categoryId) {
   if(categoryId){
      this.setState({buttonLoading: true});
      Danhmuc.actions.deletenhomDoiTuongThanhTras.request({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
        if (!isEmpty(error.response)) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      addType:0,
      ten: '',
      moTa: '',
    });
  }

  openUpdateCategory(item) {
    this.setState({
      popupAddCategory: true,
      addType: 2,
      ten: item.ten,
      moTa: item.moTa,
      doiTuongTT: item.nhomDoiTuongThanhTraId
    });
  }

  render() {
    const editNum = 2;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Danh sách nhóm đối tượng thanh tra</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('DOITUONGTHANHTRA_THEM') &&
                <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className='search-container'>
              <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
                <InputTuKhoa value={this.state.tuKhoa} onChange={ this.onChange.bind(this, 'tuKhoa') } placeholderText="Nhập từ khóa để tìm kiếm..." />
                <div className="btn-wrap">
                  <Button className='btn-green tt-search' text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
                </div>
              </form>
            </div>
            <DataTable
              header={header.nhomDoiTuongThanhTra}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent={this}
              tableLoading={this.state.tableLoading}>
              <RowItemNhomDoiTuongThanhTra/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType === editNum ? 'Chỉnh sửa đối tượng thanh tra' : 'Thêm mới đối tượng thanh tra'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body row">
              <Input className="col-12" label="Tên" value={this.state.ten} require={true} maxLength={255} onChange={this.onChange.bind(this, 'ten')} bindValidator={this} channel="danhMuc"/>
              <TextArea label="Mô tả" maxLength={255} rows={5} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className='col-12'/>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={classnames('btn-action btn-save', {
                  'btn-loading': this.state.buttonLoading
                  })} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType === editNum ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    )
  }
}

NhomDoiTuongThanhTra.defaultProps = {
  validators: {}
}
function bindStateToProps(state) {
  return {};
}
export default connect(bindStateToProps)(NhomDoiTuongThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/category/NhomDoiTuongThanhTra.jsx